import React, { useState } from "react";
import "./contact.css";
import volcano from "./volcano.jpg";
import { Button } from "react-bootstrap";
import Aos from "aos";
import "aos/dist/aos.css";

import CreateTodoModal from "./CreateTodoModal";

import { TodoList } from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    color: "orange",
    background: "white",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    inset: "50% auto auto 50%",
    /* border: 1px solid rgb(204, 204, 204), */
    /* background: rgb(255, 255, 255), */
    /* overflow: auto, */
    borderRadius: "4px",
    /* outline: none, */
    padding: "20px",

    border: "none",
  },
  overlay: {
    backgroundColor: " rgb(0, 0, 0, 0.5);",
  },
};

function Apropos() {
  const [showModal, setshowModal] = useState(false);

  const handleShowModal = () => {
    setshowModal(true);
  };

  const handleCloseModal = () => {
    setshowModal(false);
  };

  const [modalOpen, setModalOpen] = React.useState(false);
  React.useEffect(() => {
    Aos.init();
  }, []);

  const open = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <div data-aos="fade-up" data-aos-duration="1500">
      <div className="temoignage-head">
        <h1 id="apropos">A propos 📊</h1>
      </div>
      <div class="row2">
        <div class="column">
          <div class="card">
            <i class="fas fa-id-card" style={{ fontSize: "100px" }}></i>
            <br />

            <h3>
              Si vous avez des questions :
              <a
                style={{ color: "orange", textDecoration: "none" }}
                href="https://volcano72.netlify.app/#contact"
              >
                https://volcano72.netlify.app/#contact
              </a>
            </h3>
          </div>
        </div>

        <div class="column">
          <div class="card">
            <i class="fas fa-map-marker-alt" style={{ fontSize: "100px" }}></i>
            <br />
            <h3>
              12 Avenue Olivier MessiaenCentre Commercial Le Ribay , Cité
              vaurouzé
            </h3>
          </div>
        </div>

        <div class="column">
          <div class="card">
            <i class="fa fa-phone" style={{ fontSize: "100px" }}></i>
            <br />
            <h3>
              Pour réserver ou commander vous pouvez appeller ce numero 09 50 85
              13 53
            </h3>
          </div>
        </div>
      </div>
      <>
        {showModal && <CreateTodoModal closeModal={handleCloseModal} />}
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              {!showModal ? (
                <button className="apropos-but" onClick={handleShowModal}>
                  Livraison
                </button>
              ) : (
                <button className="apropos-but2" onClick={handleCloseModal}>
                  Retour
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default Apropos;
